export const h = {
  navMenu: ["ACCUEIL","RÉCOMPENSES", "HÉROS", "ÉLÉMENTS DE JEU"],

   
  }


// WEBPACK FOOTER //
// ./src/i18n/lan/fr.js